import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    apiRoot: ENV.API_ROOT,

    entities: {
        sessions: {
            apiPath: '/loader/login',

            properties: {
                username: {
                    type: 'string',
                    rules: [{ required: true }],
                },
                password: {
                    type: 'string.password',
                    rules: [{ required: true }],
                },
            },
        },
        privileges: {
            apiPath: '/loader/privileges',
        },
    },

    components: {
        LoginPage: {
            component: 'Login',
            entities: [
                {
                    name: 'sessions',
                    entityName: 'sessions',
                },
                {
                    name: 'privileges',
                    entityName: 'privileges',
                },
            ],
        },
    },

    routes: [
        {
            path: '/login',
            component: 'LoginPage',
            authentication: false,
        },
        {
            path: '/trade/externalOrderAddition',
            component: 'OrderSupplementView',
            breadcrumbName: '第三方订单补录',
        },
        {
            path: '/',
            component: 'MenuSideNavAuthentication',
            childRoutes: [],
        },
    ],
};
